import { AnnouncementVideoBase } from './AnnouncementVideoBase';
import { createReachVideoHandler } from '../../../MediaController';
import { ReachVideoHandler } from '../../../MediaController/Video';
import { toBoolean } from '../../../Utility';
import * as VideoService from '../../../Utility/VideoService';
import { condition } from '../Announcement';
import { Log } from '../../../AuxillaryService/Log';
import { Signage } from '../../../Signage';
import { ReachPlayer } from '../../../Platform';
import { AnnouncementWidget } from '../AnnouncementWidget';
import { ReachVideoAnnouncementConfiguration } from '../types';
import type { PlayTimes } from '../PlayTimes';

// WARNING: `REACH.CEF` should not be called outside of a `Platform` module.

export class AnnouncementReachVideo extends AnnouncementVideoBase<ReachVideoAnnouncementConfiguration> {
    protected _playerElementId: string;
    protected _player: ReachVideoHandler;
    protected _videoUuid: string;

    public declare configuration: ReachVideoAnnouncementConfiguration;

    /**
     * indicates if video has been loaded
     */
    protected _isVideoLoaded: boolean;

    constructor(
        configuration: ReachVideoAnnouncementConfiguration,
        widget: AnnouncementWidget,
        playTimes: PlayTimes
    ) {
        super(configuration, widget, playTimes);

        this._isVideoLoaded = false;

        this._videoUuid = configuration.video_id;

        this._playerElementId = `video_${configuration.id}_${this.screenId}_${widget.id}`;

        this._player = createReachVideoHandler({
            videoUuid: this._videoUuid,
            muted: toBoolean(widget.config.mute_videos),
            startTime: configuration.video_start_time,
        });
    }

    protected async _updateVideoLoadedStatus(): Promise<void> {
        await VideoService.getPath(this._videoUuid);
        this._isVideoLoaded = true;
    }

    getStatus(): condition {
        return this._isVideoLoaded ? condition.OK : condition.PENDING;
    }

    async initialize(): Promise<void> {
        await super.initialize();

        // Do not wait for this, we want this running asynchronously.
        this._updateVideoLoadedStatus().then();
    }

    async runPage(): Promise<void> {
        await super.runPage();

        if (REACH?.CEF && Signage.platform instanceof ReachPlayer) {
            try {
                // TODO: move this to Platform and/or VideoService
                REACH.CEF.RegisterVideoPlayed(this._videoUuid);
            } catch (error) {
                Log.Error(
                    'Failed to register that Video was played:  ' + String(error),
                    null,
                    __fileline,
                    error instanceof Error
                        ? { error: { name: error.name, message: error.message } }
                        : { error: { name: 'Unknown', message: 'Unknown' } }
                );
            }
        }
    }
}
